import { RootState } from '../storeTypes';

export const getNotificationsSelector = (state: RootState) =>
  state.notificationsState.notifications;
